export interface Params {
  id?: string;
  companyId?: string;
}

export enum PARAM_KEYS {
  id = 'id',
  companyId = 'companyId',
}
